<template>
  <div class="cliente-form-caracteristicas">
    <v-row
      align="end"
      class="caracteristica-row"
      v-for="(item, index) in caracteristicas"
      :key="index"
    >
      <v-col class="caracteristica-row__remove" cols="12" sm="1">
        <FormButton
          icon
          type="perigo"
          outlined
          class="caracteristica-btn-perigo caracteristica-row__remove-btn"
          @click="remove(item.idcaracteristica)"
        >
          <v-icon size="16">fas fa-times</v-icon>
        </FormButton>
      </v-col>
      <v-col cols="12" sm="5" class="caracteristica-row__campo">
        <FormAutocomplete
          label="Característica"
          v-model="item.idcaracteristica"
          :options="options"
          :validation="
            getValidationField(item.idcaracteristica, 'idcaracteristica')
          "
          class="form-inline-item caracteristica-campo-control mb-n6"
          @input="syncMetaFromOption(item)"
        />
      </v-col>
      <v-col cols="12" sm="6" class="caracteristica-row__valor caracteristica-row__campo">
        <FormSwitch
          style="margin-top: 0px;"
          v-if="checkBoolean(item)"
          v-model="item.descricao"
          :validation="getValidationField(item.idcaracteristica, 'descricao')"
          :label="item.text"
          @change="onChange"
        />
        <FormField
          v-else-if="checkString(item)"
          class="form-inline-item caracteristica-campo-control"
          :label="item.text"
          :validation="getValidationField(item.idcaracteristica, 'descricao')"
          v-model="item.descricao"
          @input="onChange"
        />
        <FormAutocomplete
          v-else-if="checkArraySingle(item)"
          class="form-inline-item caracteristica-campo-control"
          :label="item.text"
          :validation="getValidationField(item.idcaracteristica, 'descricao')"
          v-model="item.descricao"
          :options="itensOptions(item)"
          @input="onChange"
        />
        <FormAutocomplete
          v-else-if="checkArrayMultiplo(item)"
          class="form-inline-item caracteristica-campo-control"
          :label="item.text"
          :validation="getValidationField(item.idcaracteristica, 'descricao')"
          v-model="item.descricao"
          :options="itensOptions(item)"
          multiple
          @input="onChange"
        />
        <div v-else-if="checkDocumento(item)" class="documento-caracteristica">
          <div
            v-if="documentoTemArquivo(item.descricao)"
            class="documento-anexo form-inline-item"
          >
            <v-text-field
              class="documento-anexo__nome caracteristica-campo-control"
              :value="nomeArquivoDocumento(item)"
              :label="item.text || 'Documento'"
              outlined
              rounded
              flat
              dense
              readonly
              hide-details="auto"
              prepend-inner-icon="far fa-file-alt"
              :loading="documentoLoading === item.idcaracteristica"
            />
            <div class="documento-anexo__acoes">
              <FormButton
                type="secundario"
                outlined
                text="Download"
                beforeIcon="fas fa-download"
                :loading="documentoLoading === item.idcaracteristica"
                :disabled="documentoLoading === item.idcaracteristica"
                @click="downloadDocumento(item)"
              />
              <FormButton
                type="perigo"
                outlined
                class="caracteristica-btn-perigo"
                text="Excluir"
                beforeIcon="fas fa-trash-alt"
                :loading="documentoLoading === item.idcaracteristica"
                :disabled="documentoLoading === item.idcaracteristica"
                @click="excluirDocumento(item)"
              />
            </div>
          </div>
          <FormFile
            v-else
            :key="documentoFileInputKey(item)"
            class="form-inline-item documento-upload caracteristica-campo-control mb-n6"
            :label="item.text || 'Documento'"
            help="Máx. 1 MB — PDF, JPG, JPEG ou PNG"
            accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
            placeholder="Selecione um arquivo"
            :disabled="documentoLoading === item.idcaracteristica"
            :validation="getValidationField(item.idcaracteristica, 'descricao')"
            @file="file => onArquivoDocumento(file, item)"
          />
        </div>
      </v-col>
    </v-row>
    <v-row justify="center" class="mt-2 mb-1">
      <FormButton type="primario" @click="add" text="Nova característica" />
    </v-row>
  </div>
</template>

<script>
import FormAutocomplete from "@/components/form/FormAutocomplete";
import FormButton from "@/components/form/FormButton";
import FormSwitch from "@/components/form/FormSwitch";
import FormField from "@/components/form/FormField";
import FormFile from "@/components/form/FormFile";
import { mapGetters } from "vuex";
import * as _ from "lodash";
import ApiWeb from "@/service/api-web";
import {
  documentoTemArquivo,
  parseDescricaoDocumento,
  serializePending,
  validarArquivoDocumento
} from "./documento-cliente.util";

export default {
  name: "ClienteFormCaracteristica",
  components: {
    FormField,
    FormFile,
    FormSwitch,
    FormAutocomplete,
    FormButton
  },
  props: {
    value: {
      type: Array,
      default: () => [],
      required: true
    },
    validation: {
      type: Object,
      default: () => null,
      required: false
    },
    mode: {
      type: String,
      default: "add"
    },
    idcadastroextracliente: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    caracteristicas: [
      {
        idcaracteristica: "",
        obrigatorio: "",
        descricao: "",
        tipo: "",
        text: "",
        id: Math.random() * 10000,
        itens_caracteristica: [],
        multiplo: false
      }
    ],
    documentoLoading: null
  }),
  computed: {
    ...mapGetters(["getListCaracteristicasCliente", "getFornecedorId"]),
    options() {
      return this.getListCaracteristicasCliente.map(item => ({
        text: item.nome,
        value: item.idcaracteristica,
        idcaracteristica: item.idcaracteristica,
        obrigatorio: item.obrigatorio,
        descricao: item.descricao,
        tipo: item.tipo,
        itens_caracteristica: item.itens_caracteristica,
        multiplo: item.multiplo
      }));
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.caracteristicas = newVal;
      }
    }
  },
  created() {
    if (this.value) {
      this.caracteristicas = this.value;
    }
  },
  methods: {
    documentoTemArquivo,
    add() {
      this.caracteristicas.push({
        idcaracteristica: "",
        descricao: "",
        obrigatorio: false,
        tipo: "string",
        id: Math.random() * 10000
      });
    },
    syncMetaFromOption(item) {
      const cara = (this.options || []).find(
        c => c.idcaracteristica === item.idcaracteristica
      );
      if (cara) {
        item.tipo = cara.tipo;
        item.obrigatorio = cara.obrigatorio;
        item.text = cara.text;
        item.itens_caracteristica = cara.itens_caracteristica;
        item.multiplo = cara.multiplo;
      }
      this.onChange();
    },
    checkBoolean(item) {
      const cara = (this.options || []).find(
        c => c.idcaracteristica === item.idcaracteristica
      );
      return cara && cara.tipo === "boolean";
    },
    checkString(item) {
      const cara = (this.options || []).find(
        c => c.idcaracteristica === item.idcaracteristica
      );
      return cara && cara.tipo === "string";
    },
    checkArraySingle(item) {
      const cara = (this.options || []).find(
        c => c.idcaracteristica === item.idcaracteristica
      );
      return cara && cara.tipo === "array" && cara.multiplo === false;
    },
    checkArrayMultiplo(item) {
      const cara = (this.options || []).find(
        c => c.idcaracteristica === item.idcaracteristica
      );
      return cara && cara.tipo === "array" && cara.multiplo === true;
    },
    checkDocumento(item) {
      const cara = (this.options || []).find(
        c => c.idcaracteristica === item.idcaracteristica
      );
      return cara && cara.tipo === "documento";
    },
    nomeArquivoDocumento(item) {
      const parsed = parseDescricaoDocumento(item.descricao);
      if (parsed.kind === "empty") {
        return "";
      }
      return parsed.nome_arquivo;
    },
    documentoFileInputKey(item) {
      const id = item.idcaracteristica || item.id || "novo";
      return `doc-upload-${id}-${this.documentoTemArquivo(item.descricao) ? 1 : 0}`;
    },
    async onArquivoDocumento(file, item) {
      if (!file || !item.idcaracteristica) {
        return;
      }
      const validacao = validarArquivoDocumento(file);
      if (!validacao.ok) {
        this.$vueOnToast.pop("error", validacao.error);
        return;
      }
      this.documentoLoading = item.idcaracteristica;
      try {
        const { data } = await ApiWeb.v4.cliente.caracteristic.uploadDocumento(
          this.getFornecedorId,
          item.idcaracteristica,
          file
        );
        item.descricao = serializePending({
          storage_key: data.storage_key,
          nome_arquivo: data.nome_arquivo || file.name
        });
        this.onChange();
        this.$vueOnToast.pop("success", "Arquivo enviado com sucesso");
      } catch (err) {
        const msg =
          _.get(err, "response.data.message") ||
          "Falha ao enviar o documento";
        this.$vueOnToast.pop("error", msg);
      } finally {
        this.documentoLoading = null;
      }
    },
    async downloadDocumento(item) {
      const parsed = parseDescricaoDocumento(item.descricao);
      if (parsed.kind === "empty") {
        return;
      }
      if (this.mode === "add" || !this.idcadastroextracliente) {
        this.$vueOnToast.pop(
          "error",
          "Salve o cliente antes de baixar o documento"
        );
        return;
      }
      this.documentoLoading = item.idcaracteristica;
      try {
        const { data } = await ApiWeb.v4.cliente.caracteristic.downloadDocumento(
          {
            idfornecedor: this.getFornecedorId,
            idcadastroextracliente: this.idcadastroextracliente,
            idcaracteristica: item.idcaracteristica,
            storage_key: parsed.storage_key
          }
        );
        if (data && data.url) {
          window.open(data.url, "_blank", "noopener,noreferrer");
        }
      } catch (err) {
        const msg =
          _.get(err, "response.data.message") ||
          "Falha ao gerar link de download";
        this.$vueOnToast.pop("error", msg);
      } finally {
        this.documentoLoading = null;
      }
    },
    async excluirDocumento(item) {
      const parsed = parseDescricaoDocumento(item.descricao);
      if (this.mode === "add" || parsed.kind === "pending") {
        item.descricao = "";
        this.onChange();
        return;
      }
      if (!this.idcadastroextracliente) {
        this.$vueOnToast.pop(
          "error",
          "Cadastro extra do cliente não encontrado"
        );
        return;
      }
      this.documentoLoading = item.idcaracteristica;
      try {
        await ApiWeb.v4.cliente.caracteristic.excluirDocumentoVinculo({
          idfornecedor: this.getFornecedorId,
          idcadastroextracliente: this.idcadastroextracliente,
          idcaracteristica: item.idcaracteristica
        });
        item.descricao = "";
        this.onChange();
        this.$vueOnToast.pop("success", "Documento excluído");
      } catch (err) {
        const msg =
          _.get(err, "response.data.message") ||
          "Falha ao excluir o documento";
        this.$vueOnToast.pop("error", msg);
      } finally {
        this.documentoLoading = null;
      }
    },
    itensOptions(item) {
      const cara = (this.options || []).find(
        c => c.idcaracteristica === item.idcaracteristica
      );
      return cara && cara.itens_caracteristica ? cara.itens_caracteristica : [];
    },
    remove(id) {
      this.caracteristicas = this.caracteristicas.filter(
        item => item.idcaracteristica != id
      );
      this.onChange();
    },
    onChange() {
      this.$emit("input", this.caracteristicas);
      this.$emit("change", this.caracteristicas);
    },
    getValidationField(id, columns) {
      if (this.validation && this.validation.$each) {
        for (const i in this.validation.$each.$iter) {
          let val = this.validation.$each.$iter[i];
          if (_.get(val, "$model.idcaracteristica", "") == id) {
            return _.get(val, columns, null);
          }
        }
      }
      return null;
    }
  }
};
</script>

<style scoped>
.cliente-form-caracteristicas .caracteristica-row {
  margin-bottom: 8px;
}

@media (min-width: 600px) {
  .cliente-form-caracteristicas .caracteristica-row {
    flex-wrap: nowrap;
  }
}

.cliente-form-caracteristicas .caracteristica-row__valor {
  min-width: 0;
}

.cliente-form-caracteristicas .caracteristica-row__remove {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.cliente-form-caracteristicas .caracteristica-row__campo {
  display: flex;
  align-items: flex-end;
}

.cliente-form-caracteristicas .caracteristica-campo-control {
  flex: 1 1 auto;
  width: 100%;
}

.cliente-form-caracteristicas >>> .caracteristica-row .v-input {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
}

.cliente-form-caracteristicas
  >>> .caracteristica-campo-control.v-text-field--outlined.v-input--dense
  .v-input__control,
.cliente-form-caracteristicas
  >>> .caracteristica-campo-control.v-input--is-label-active.v-input--dense
  .v-input__control {
  min-height: 40px;
}

.cliente-form-caracteristicas >>> .caracteristica-row__remove-btn.v-btn {
  height: 40px;
  min-width: 40px !important;
  width: 40px;
  margin-bottom: 0;
}

.cliente-form-caracteristicas >>> .caracteristica-btn-perigo.v-btn--outlined {
  border: thin solid var(--danger-color) !important;
  color: var(--danger-color) !important;
}

.cliente-form-caracteristicas >>> .caracteristica-btn-perigo.v-btn--outlined .v-icon {
  color: var(--danger-color) !important;
}

.documento-caracteristica {
  width: 100%;
}

.documento-anexo {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 10px;
  width: 100%;
}

.documento-anexo__nome {
  flex: 1 1 auto;
  min-width: 0;
}

.documento-anexo__nome >>> .v-text-field__slot input {
  text-overflow: ellipsis;
}

.documento-anexo__acoes {
  display: flex;
  flex-shrink: 0;
  align-items: flex-end;
  gap: 8px;
  padding-bottom: 0;
}

.cliente-form-caracteristicas >>> .documento-anexo__acoes .formButton {
  height: 40px;
  margin-bottom: 0;
}

.documento-upload >>> .v-file-input__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 959px) {
  .documento-anexo {
    flex-wrap: wrap;
  }
}
</style>
